export default __webpack_public_path__ + "images/0xd4d42f0b6def4ce0383636770ef773390d85c61a.png";